
// jshint asi: true
// jshint devel: true
// jshint unused: false

function isScrolledIntoView(elem) {
	var docViewTop = $(window).scrollTop()
	var docViewBottom = docViewTop + $(window).height()
	var elemTop = $(elem).offset().top
	var elemBottom = elemTop
	return (elemBottom <= docViewBottom)
}

function doActivate(i,div) {
	setTimeout(function() {
		$(div).addClass('active')
		 var svg = $(div).find('textarea').val()
		 $(div).find('textarea').remove()
		 $(div).prepend(svg)
	}, i*500)
}

function activateChildren() {

	$('.data_holder_JS').each(function() {
		if (isScrolledIntoView(this) === true) {
			var children = $(this).children('.data_JS:not(.active)')
			for (var i = 0; i < children.length; i++) {
				doActivate(i+1,children[i])
			}
		}
	})

}


